/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Home_Pulse_Title_Buildid1Inputs */

const id_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.id}`)
};

const ms_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Binaan ${i?.id}`)
};

const da_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.id}`)
};

const de_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.id}`)
};

const en_us2_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.id}`)
};

const es_es2_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilación ${i?.id}`)
};

const es_mx2_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilación ${i?.id}`)
};

const fil_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.id}`)
};

const fr_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilation ${i?.id}`)
};

const it_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.id}`)
};

const hu_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.id}`)
};

const nl_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.id}`)
};

const no_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.id}`)
};

const pl_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kompilacja ${i?.id}`)
};

const pt_br2_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.id}`)
};

const pt_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilação ${i?.id}`)
};

const ro_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilare ${i?.id}`)
};

const fi_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Koontiversio ${i?.id}`)
};

const sv_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bygge ${i?.id}`)
};

const vi_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bản dựng ${i?.id}`)
};

const tr_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yapı ${i?.id}`)
};

const cs_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sestavení ${i?.id}`)
};

const bg_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Компилация ${i?.id}`)
};

const ru_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сборка ${i?.id}`)
};

const uk_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Збірка ${i?.id}`)
};

const ar_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`البنية ${i?.id}`)
};

const hi_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`बिल्ड ${i?.id}`)
};

const th_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`บิลด์ ${i?.id}`)
};

const ja_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビルド ${i?.id}`)
};

const zh_cn2_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`构建ID ${i?.id}`)
};

const zh_hant1_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`建置ID ${i?.id}`)
};

const ko_home_pulse_title_buildid1 = /** @type {(inputs: Home_Pulse_Title_Buildid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`빌드 ${i?.id}`)
};

/**
* | output |
* | --- |
* | "Build {id}" |
*
* @param {Home_Pulse_Title_Buildid1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_title_buildid1 = /** @type {((inputs: Home_Pulse_Title_Buildid1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Title_Buildid1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_title_buildid1(inputs)
	if (locale === "ms") return ms_home_pulse_title_buildid1(inputs)
	if (locale === "da") return da_home_pulse_title_buildid1(inputs)
	if (locale === "de") return de_home_pulse_title_buildid1(inputs)
	if (locale === "en-US") return en_us2_home_pulse_title_buildid1(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_title_buildid1(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_title_buildid1(inputs)
	if (locale === "fil") return fil_home_pulse_title_buildid1(inputs)
	if (locale === "fr") return fr_home_pulse_title_buildid1(inputs)
	if (locale === "it") return it_home_pulse_title_buildid1(inputs)
	if (locale === "hu") return hu_home_pulse_title_buildid1(inputs)
	if (locale === "nl") return nl_home_pulse_title_buildid1(inputs)
	if (locale === "no") return no_home_pulse_title_buildid1(inputs)
	if (locale === "pl") return pl_home_pulse_title_buildid1(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_title_buildid1(inputs)
	if (locale === "pt") return pt_home_pulse_title_buildid1(inputs)
	if (locale === "ro") return ro_home_pulse_title_buildid1(inputs)
	if (locale === "fi") return fi_home_pulse_title_buildid1(inputs)
	if (locale === "sv") return sv_home_pulse_title_buildid1(inputs)
	if (locale === "vi") return vi_home_pulse_title_buildid1(inputs)
	if (locale === "tr") return tr_home_pulse_title_buildid1(inputs)
	if (locale === "cs") return cs_home_pulse_title_buildid1(inputs)
	if (locale === "bg") return bg_home_pulse_title_buildid1(inputs)
	if (locale === "ru") return ru_home_pulse_title_buildid1(inputs)
	if (locale === "uk") return uk_home_pulse_title_buildid1(inputs)
	if (locale === "ar") return ar_home_pulse_title_buildid1(inputs)
	if (locale === "hi") return hi_home_pulse_title_buildid1(inputs)
	if (locale === "th") return th_home_pulse_title_buildid1(inputs)
	if (locale === "ja") return ja_home_pulse_title_buildid1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_title_buildid1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_title_buildid1(inputs)
	return ko_home_pulse_title_buildid1(inputs)
});
export { home_pulse_title_buildid1 as "home.pulse.title.buildId" }